<template>
  <div class="page-wrapper pb-24 lg:pb-32">
    <MarkupSectionHeaderH1
      :config-data="{
        TitleFirstRow: modifiedConfigData.headerFirstRow.Title,
        TitleStyle: modifiedConfigData.headerFirstRow.TitleStyle,
        TitleSecondRow: modifiedConfigData.headerSecondRow.Title,
      }"
    />

    <MarkupSectionText
      v-if="modifiedConfigData.ingress.Text"
      class="mt-16 md:mt-24"
      :config-data="modifiedConfigData.ingress"
    />

    <MarkupUspWrapper
      class="mt-16 lg:mt-24"
      :config-data="modifiedConfigData.usp"
    />

    <ManufacturerPagesNav
      :links="modifiedConfigData.manufacturerLinks"
      :active-page-label="manufacturerSlug"
    />
  </div>
</template>

<script lang="ts" setup>
interface Props {
  configData: {
    Header: {
      Row1?: string;
      Row2?: string;
    };
    Ingress: {
      Text?: string;
    };
    BulletList: {
      Bullet: {
        Row1: string;
        Row2: string;
      }[];
    };
    ManufacturerLinks?: {
      Url?: string;
      Label?: string;
    }[];
  };
}

const props = defineProps<Props>();

const route = useRoute();

const manufacturerSlug = computed(() => {
  let slug = '';

  if (
    Array.isArray(route.params.manufacturer) &&
    !!route.params.manufacturer &&
    route.params.manufacturer.length > 0
  ) {
    slug = route.params.manufacturer[0];
  } else {
    slug = `${route.params.manufacturer}`.replaceAll('/', '');
  }

  return slug;
});

const modifiedConfigData = computed(() => ({
  headerFirstRow: {
    Title: props.configData.Header.Row1 ?? 'Mobiltelefoner',
    TitleStyle: 'boxed',
  },
  headerSecondRow: {
    Title: props.configData.Header.Row2,
    TitleStyle: 'boxed',
  },
  ingress: {
    Text: props.configData.Ingress?.Text ?? '',
  },
  usp: {
    Items: props.configData.BulletList.Bullet.map((item) => ({
      Icon: 'check-circle-white',
      Label: item.Row1,
      SubLabel: item.Row2,
    })),
  },
  manufacturerLinks: (props.configData?.ManufacturerLinks || [])
    .filter((link) => link.Label && link.Url)
    .map((link) => ({
      relativeUrl: link.Url || '',
      label: link.Label || '',
    })),
}));
</script>
